import { ActionIcon, Indicator, Popover, Text, createStyles, Checkbox, Group } from '@mantine/core';
import { IconAdjustmentsHorizontal } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';

// Custom styles
const useStyles = createStyles((theme) => ({
	label: {
		fontSize: 14,
		lineHeight: '18px',
		fontWeight: 'bold',
		padding: 12
	},
	optionLabel: {
		textTransform: 'capitalize',
		fontSize: 14,
		lineHeight: '18px',
	},
	optionRow: {
		padding: '8px 12px',
		cursor: 'pointer',
		'&:hover': {
			backgroundColor: 'rgba(230, 210, 246, 0.5)'
		}
	},
	isSelected: {
		backgroundColor: 'rgba(230, 210, 246, 0.5)'
	}
}));

const FilterSelector = ({ label, options, selected }) => {

	// State and hooks
	const [opened, setOpened] = useState(false);
	const { classes, cx } = useStyles();
	const [checked, setChecked] = useState(true);

	// Listen for changes
	useEffect(() => {

		// If one is checked, disable "all"
		if (selected && selected[0].length !== 0) setChecked(false);

		// If all are unchecked, enable "all"
		if (selected && selected[0].length === 0) setChecked(true);

	}, [selected]);

	// Each option
	const eachOption = (val, i) => {

		return (
			<Group
				className={cx(classes.optionRow, { [classes.isSelected]: selected[0].includes(val.id) })}
				key={i}
				position="apart"
				onClick={() => selected[1](ids => ids.includes(val.id) ? ids.filter(item => item !== val.id) : [...ids, val.id])}
			>
				{/* Label */}
				<Text className={classes.optionLabel}>
					{val.name.toLowerCase()}
				</Text>
				{/* Checkbox */}
				<Checkbox
					size="xs"
					style={{ cursor: 'pointer' }}
					checked={selected[0].includes(val.id)}
				/>
			</Group>
		);

	}

	// Trigger selection of all elements
	const triggerAll = () => {

		// If all are not selected, do nothing
		if (selected[0].length === 0) return;

		// De-select all elements
		selected[1]([]);

		// Check "all"
		setChecked(true);

	}
	
	return (
		<Popover
			opened={opened}
			onChange={setOpened}
			shadow="md"
			width={200}
			position="bottom-end"
			withArrow
			offset={3}
			arrowOffset={10}
		>
			{/* Opener */}
			<Popover.Target>
				{/* Purple Circle */}
				<Indicator
					offset={6}
					size={14}
					withBorder
					disabled={checked}
				>
					{/* Icon */}
					<ActionIcon
						variant="white"
						onClick={() => setOpened((o) => !o)}
					>
						<IconAdjustmentsHorizontal
							stroke={1.7}
							size={22}
						/>
					</ActionIcon>
				</Indicator>
			</Popover.Target>
			{/* Content */}
			<Popover.Dropdown
				p={0}
				pb={8}
			>
				{/* Label */}
				<Text className={classes.label}>
					{label}
				</Text>
				{/* Main Option */}
				<Group
					className={cx(classes.optionRow, { [classes.isSelected]: checked })}
					position="apart"
					onClick={triggerAll}
				>
					{/* Label */}
					<Text
						className={classes.optionLabel}
						fw="bold"
					>
						Todos
					</Text>
					{/* Checkbox */}
					<Checkbox
						size="xs"
						style={{ cursor: 'pointer' }}
						checked={checked}
						onChange={() => {}}
					/>
				</Group>
				{/* Items */}
				{options?.map(eachOption)}
			</Popover.Dropdown>
		</Popover>
	);

}

export default FilterSelector;
